import { queryOptions } from '@tanstack/vue-query';
import type { ComputedRef } from 'vue';
import { route } from 'ziggy-js';

import { axios } from '@/helpers/axios';
import type { TrendReportResource } from '@/modules/trending/types';

export function trendingReportQueryOptions(params?: ComputedRef<{
  category?: string
  date?: string
  limit: number
  marketplace?: 'etsy'
  period: 'monthly'
}>) {
  return queryOptions({
    queryKey: ['trending-report', params],
    queryFn: ({ signal }) => axios.get<TrendReportResource[]>(
      route('api.trending-report'),
      {
        params: params.value,
        signal,
      },
    ),
    select: (data) => data.data,
  });
}

interface TrendingReportAvailabilityResource {
  categories: string[]
  date: string
}

export function trendingReportAvailabilityQueryOptions() {
  return queryOptions({
    queryKey: ['trending-report', 'availability'],
    queryFn: ({ signal }) => axios.get<TrendingReportAvailabilityResource[]>(
      route('api.trending-report.availability'),
      {
        signal,
      },
    ),
    select: (data) => data.data,
  });
}
